import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Breadcrumb, Table, Input, Select, Space, Form, Tooltip } from "antd";
import ButtonField from "../../common/htmlComponents/ButtonField";
import { Collapse } from "antd";
import ExelDownload from "../../image/exeldownload.svg";
import { getRequest } from "../../axios";
import { ErrorNotificationMsg } from "../../utils/Notifications";
import { authUserData } from "../../utils/Helper";
import { Option } from "antd/lib/mentions";

const handleChange = (value) => {
};

const { Panel } = Collapse;

// const acolumns = [
//   {
//     title: 'A',
//     dataIndex: 'A',
//     key: '1',
//     width: 50,
//   },
//   {
//     title: 'General cement',
//     dataIndex: 'Generalcement',
//     key: '2',
//   },
//   {
//     title: 'Site name 1',
//     dataIndex: 'Sitename1',
//     key: '3',
//     width: 150,
//   },
//   {
//     title: 'Site name 2',
//     dataIndex: 'Sitename2',
//     key: '4',
//     width: 150,
//   },
//   {
//     title: 'Site name 3',
//     dataIndex: 'Sitename3',
//     key: '5',
//     width: 150,
//   },
//   {
//     title: 'Site name 4',
//     dataIndex: 'Sitename4',
//     key: '6',
//     width: 150,
//   },
//   {
//     title: 'UOM.',
//     dataIndex: 'UOM',
//     key: '7',
//     width: 150,
//   },
//   {
//     title: 'TOTAL QTY.',
//     dataIndex: 'TOTAL',
//     key: '8',
//     width: 150,
//   },
// ];
// const adata = [
//   {
//     key: '1',
//     A: '1',
//     Generalcement: <label>OPC 43</label>,
//     Sitename1: <Input placeholder="" />,
//     Sitename2: <Input placeholder="" />,
//     Sitename3: <Input placeholder="" />,
//     Sitename4: <Input placeholder="" />,
//     UOM: <Select
//       defaultValue="MT"
//       style={{
//         width: 120,
//       }}
//       onChange={handleChange}
//       options={[
//         {
//           value: 'jack',
//           label: 'Jack',
//         },
//         {
//           value: 'lucy',
//           label: 'Lucy',
//         },

//         {
//           value: 'Yiminghe',
//           label: 'yiminghe',
//         },
//       ]}
//     />,
//     TOTAL: '100'
//   },
//   {
//     key: '2',
//     A: '2',
//     Generalcement: <label>OPC 43</label>,
//     Sitename1: <Input placeholder="" />,
//     Sitename2: <Input placeholder="" />,
//     Sitename3: <Input placeholder="" />,
//     Sitename4: <Input placeholder="" />,
//     UOM: <Select
//       defaultValue="MT"
//       style={{
//         width: 120,
//       }}
//       onChange={handleChange}
//       options={[
//         {
//           value: 'jack',
//           label: 'Jack',
//         },
//         {
//           value: 'lucy',
//           label: 'Lucy',
//         },

//         {
//           value: 'Yiminghe',
//           label: 'yiminghe',
//         },
//       ]}
//     />,
//     TOTAL: '100'
//   },
//   {
//     key: '3',
//     A: '3',
//     Generalcement: <label>OPC 43</label>,
//     Sitename1: <Input placeholder="" />,
//     Sitename2: <Input placeholder="" />,
//     Sitename3: <Input placeholder="" />,
//     Sitename4: <Input placeholder="" />,
//     UOM: <Select
//       defaultValue="MT"
//       style={{
//         width: 120,
//       }}
//       onChange={handleChange}
//       options={[
//         {
//           value: 'jack',
//           label: 'Jack',
//         },
//         {
//           value: 'lucy',
//           label: 'Lucy',
//         },

//         {
//           value: 'Yiminghe',
//           label: 'yiminghe',
//         },
//       ]}
//     />,
//     TOTAL: '100'
//   },
//   {
//     key: '4',
//     A: '4',
//     Generalcement: <label>OPC 43</label>,
//     Sitename1: <Input placeholder="" />,
//     Sitename2: <Input placeholder="" />,
//     Sitename3: <Input placeholder="" />,
//     Sitename4: <Input placeholder="" />,
//     UOM: <Select
//       defaultValue="MT"
//       style={{
//         width: 120,
//       }}
//       onChange={handleChange}
//       options={[
//         {
//           value: 'jack',
//           label: 'Jack',
//         },
//         {
//           value: 'lucy',
//           label: 'Lucy',
//         },
//         {
//           value: 'Yiminghe',
//           label: 'yiminghe',
//         },
//       ]}
//     />,
//     TOTAL: '100'
//   },
// ];

const FloatRFQPurchaseRequisitionAssignDetails = () => {
  const [
    FloatRFQPurchaseRequisitionAssignDetails,
    setFloatRFQPurchaseRequisitionAssignDetails,
  ] = useState([]);
  const [categoryTreeId, setCategoryTreeId] = useState("");

  const { id } = useParams();

  const { t } = useTranslation();
  const navigate = useNavigate();
  const onChange = (key) => {
  };

  const expandedRowRender = () => {
    const columns = [
      {
        title: "sr No.",
        dataIndex: "srNo",
        key: "srNo",
      },
      {
        title: "PO NUMBER",
        dataIndex: "PONUMBER",
        key: "PONUMBER",
      },
      {
        title: "Po date",
        dataIndex: "Podate",
        key: "Podate",
      },
      {
        title: "Vendor",
        dataIndex: "Vendor",
        key: "Vendor",
      },
      {
        title: "delivery status",
        dataIndex: "deliverystatus",
        key: "deliverystatus",
      },
      {
        title: "QTY",
        dataIndex: "QTY",
        key: "QTY",
      },
      {
        title: "UOM",
        dataIndex: "operation",
        key: "operation",
        render: () => (
          <Space size="middle">
            <Select
              defaultValue="MT"
              style={{
                width: 120,
              }}
              onChange={handleChange}
              options={[
                {
                  value: "jack",
                  label: "Jack",
                },
                {
                  value: "lucy",
                  label: "Lucy",
                },

                {
                  value: "Yiminghe",
                  label: "yiminghe",
                },
              ]}
            />
          </Space>
        ),
      },
    ];
    const data = [];
    for (let i = 0; i < 3; ++i) {
      data.push({
        key: i.toString(),
        srNo: "1",
        PONUMBER: "00001",
        Podate: "24-08-23 09:05",
        Vendor: "Vendor 1",
        deliverystatus: "Partially",
        QTY: "25",
      });
    }
    return (
      <Table
        className="subtbl"
        columns={columns}
        dataSource={data}
        pagination={false}
      />
    );
  };

  const CompanyID = authUserData()?.company ? authUserData()?.company : null;

  useEffect(() => {
    const getPurchaseRequisitionDetails = async () => {
      // setLoading(true);

      try {
        let apiResponse = await getRequest(`purchase-requisition/${id}`);
        if (apiResponse.data.data) {
          setFloatRFQPurchaseRequisitionAssignDetails(apiResponse.data.data);
          const categoryTreeId = apiResponse.data.data.category_tree;
          setCategoryTreeId (categoryTreeId)
          // settotalCount(apiResponse.data.count);
        } else {
          ErrorNotificationMsg(t("error_in_purchase_requisition"));
        }
        // setLoading(false);
      } catch (error) {
        //setLoading(false);
      }
    };
    getPurchaseRequisitionDetails();
  }, []);

  const handleExcelDownload = async () => {
    const endpoint = `purchase-requisition/${id}/download-single-pr-history-excel/`;
    const fileType = "csv";

    try {
      //setBtnloading(true);
      await getRequest(endpoint)
        .then((response) => {
          const blob = new Blob([response.data], {
            type: "text/csv",
          });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          //link.download = `purchase_requisition_${id}-${+new Date()}.${fileType}`;
          link.download = `purchase_requisition_${CompanyID}-${+new Date()}.${fileType}`;
          link.click();
          //setBtnloading(false);
        })
        .catch((error) => {
          ErrorNotificationMsg(t(`err_${fileType}_download`));
        });
    } catch (error) {
      //setBtnloading(false);
      ErrorNotificationMsg(error);
    }
  };

  const handleDownloadPDF = async () => {
    try {
      const endpoint = `purchase-requisition/${id}/download-pr-history-pdf/`;
      const response = await getRequest(endpoint, { responseType: "blob" }); // Specify responseType as 'blob' to handle binary data (PDF)
      const blob = new Blob([response.data], {
        type: "application/pdf", // Set MIME type to application/pdf for PDF file
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `purchase_requisition_${id}-${+new Date()}.pdf`; // Set file extension to .pdf
      link.click();
    } catch (error) {
      ErrorNotificationMsg("Error downloading PR");
    }
  };

  const AssignRenderTables = () => {
    if (!FloatRFQPurchaseRequisitionAssignDetails.purchase_requisition_details)
      return null;

    // Group purchase_requisition_details by sub_category
    const groupedDetails = {};
    FloatRFQPurchaseRequisitionAssignDetails.purchase_requisition_details.forEach(
      (detail) => {
        const subCategory = detail.sub_category;
        if (!groupedDetails[subCategory]) {
          groupedDetails[subCategory] = { sites: {}, details: [] };
        }
        groupedDetails[subCategory].details.push(detail);
        detail.site_wise.forEach((site) => {
          groupedDetails[subCategory].sites[site.site_name] = true;
        });
      }
    );

    return Object.entries(groupedDetails).map(
      ([subCategory, { sites, details }], index) => {
        const siteNames = Object.keys(sites);
        // const defaultUOMName = "Unit Of Measurement";
        // const defaultTotalQuantity = "Total Quantity";
        const data = [];
        // for (let i = 0; i < 3; ++i) {
        //   data.push({
        //     key: i.toString(),
        //     date: '2014-12-24 23:12:00',
        //     name: 'This is production name',
        //     upgradeNum: 'Upgraded: 56',
        //   });
        // }
        details.map((detail) =>
          data.push({
            ...detail,
            key: detail.pr_details_id.toString(),
            totalQuantity: `${detail.total_quantity} ${detail.unit_of_measurement_name}`,
          })
        );

        const siteNameColumns = siteNames.map((site, index) => ({
          title: site,
          dataIndex: index,
          key: index,
          width: 170,
        }));

        const columns = [
          {
            title: `${index + 1}`,
            dataIndex: "A",
            key: "1",
            width: 20,
          },
          {
            title: `${subCategory}`,
            dataIndex: `${subCategory}`,
            key: `${subCategory}`,
          },

          ...siteNameColumns,
          {
            title: "UOM.",
            dataIndex: "UOM",
            key: "7",
            width: 200,
          },
          {
            title: "TOTAL QTY.",
            dataIndex: "TOTAL",
            key: "8",
            width: 150,
          },
        ];

        const thead = <Table columns={columns} />;

        return (
          // <Panel key={index.toString()} header={thead}>
          //    header={`${subCategory}  ${siteNames.join(' ')}  ${defaultUOMName}  ${defaultTotalQuantity}`}
          //  <Panel key={index.toString()} header={`${subCategory}  ${siteNames.join(' ')}  ${defaultUOMName}  ${defaultTotalQuantity}`} >

          <Panel key={index.toString()} header={thead}>
            <Table
              columns={[
                // ...columns,
                {
                  title: "Type Name",
                  dataIndex: "material_type_name",
                  key: "material_type_name",
                },
                {
                  title: "Site Input",
                  dataIndex: "siteInput",
                  key: "siteInput",
                  width: 150,
                  render: (text, record) => (
                    <Space>
                      {record.site_wise.map((site, siteIndex) => (
                        <Input
                          readOnly
                          key={siteIndex}
                          style={{ width: "150px" }}
                          value={site.quantity}
                        />
                      ))}
                    </Space>
                  ),
                },
                {
                  title: "UOM",
                  dataIndex: "unit_of_measurement",
                  key: "unit_of_measurement",
                  width: 150,
                  render: (text, record) => (
                    <Select
                      disabled
                      style={{ width: "150px" }}
                      defaultValue={record.unit_of_measurement_name}
                    >
                      <Option
                        key={record.id}
                        value={record.unit_of_measurement_name}
                      >
                        {record.unit_of_measurement_name}
                      </Option>
                    </Select>
                  ),
                },
                {
                  title: "Total Quantity",
                  dataIndex: "totalQuantity",
                  key: "totalQuantity",
                  width: 150,
                  render: (text, record) => (
                    <Input
                      key={record.id}
                      style={{ width: "150px" }}
                      value={record.total_quantity}
                    />
                  ),
                },
              ]}
              // dataSource={details.map(detail => ({
              //   ...detail,
              //   totalQuantity: `${detail.total_quantity} ${detail.unit_of_measurement_name}`,
              // }))}
              dataSource={data}
              pagination={false}
              expandable={{
                expandedRowRender: (record) => expandedRowRender(),
                defaultExpandedRowKeys: ["0"],
              }}
            />
          </Panel>
        );
      }
    );
  };
  const colors = ["#094E8F"];
  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
          <Tooltip
              color={colors}
              placement="right"
              title={
                <span style={{ color: "#fff" }}>
                 Access detailed information and status updates for this Purchase Requisition (PR). 
                 Review item specifications, approvals, and any associated documents.
                </span>
              }
            >
            <h3>Purchase Requisition (PR) - Details</h3>
            </Tooltip>

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to={`/request-for-quotation/float-rfq-assign-pr/${categoryTreeId}`}>
                 Assign Purchase Requisition (PR)
                </Link>
           
              </Breadcrumb.Item>
              <Breadcrumb.Item>Purchase Requisition Details</Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </div>
      </div>
      <section className="grid-sec mt-5">
        <div className="PR-body">
          <div className="filterrow">
            <div className="filtercol">
              <Space wrap>
                <div className="lblwrp">
                  <label>PR Creator</label>
                  <h6>{FloatRFQPurchaseRequisitionAssignDetails.pr_creator}</h6>
                </div>
                <div className="lblwrp">
                  <label>PR Number</label>
                  <h6>{FloatRFQPurchaseRequisitionAssignDetails.pr_number}</h6>
                </div>
                {/* <div className="lblwrp">
                  <label>PR Approval Date</label>
                  <h6>{FloatRFQPurchaseRequisitionAssignDetails.pr_approval_date}</h6>
                </div> */}
                <div className="lblwrp">
                  <label>Estimated PR Value</label>
                  <h6>₹ {FloatRFQPurchaseRequisitionAssignDetails.total_amount}</h6>
                </div>
                <div className="lblwrp assignb">
                  <Form.Item
                    name="assign_to_buyer"
                    label="Assign To Buyer"
                    // rules={[
                    //   {
                    //     required: true,
                    //     message: (
                    //       <Trans>{t("val_assign_site_to_vendor")}</Trans>
                    //     ),
                    //   },
                    // ]}
                  >
                    <Select
                      className="cust-selectBox"
                      //mode="multiple"
                      disabled
                      showArrow
                      showSearch
                      allowClear
                      placeholder={
                        FloatRFQPurchaseRequisitionAssignDetails.pr_assign_to_buyer
                      }
                      // optionFilterProp="children"
                      // onChange={handleSiteChange}
                      // value={state.assign_site_to_vendor}
                    >
                      {/* {siteEmployee &&
                        siteEmployee.length > 0 &&
                        siteEmployee.map((item) => (
                          <Select.Option
                            key={item.site_id}
                            value={item.site_id}
                          >
                            {item.site_name}
                          </Select.Option>
                        ))} */}
                    </Select>
                  </Form.Item>
                </div>
              </Space>
            </div>

            <div className="btnscol">
              <Space>
                <ButtonField
                  className="SaveGradiantBtn"
                  type="primary"
                  htmlType="Exel"
                  label="Excel"
                  onClick={handleExcelDownload}
                  icon={<img src={ExelDownload} alt="Plus Square" />}
                />
                <ButtonField
                  className="SaveGradiantBtn"
                  type="primary"
                  htmlType="PDF"
                  label="PDF"
                  onClick={handleDownloadPDF}
                  icon={<img src={ExelDownload} alt="Plus Square" />}
                />
              </Space>
            </div>
          </div>
          <Collapse defaultActiveKey={["0"]} onChange={onChange}>
            {/*  <Panel header={thead} key="1">
              <Table columns={acolumns} dataSource={adata} pagination={false} expandable={{
                expandedRowRender,
                defaultExpandedRowKeys: ['0'],
              }} />
            </Panel> */}

            {AssignRenderTables()}

            {/*            <Panel header={thead} key="2">
              <Table columns={acolumns} dataSource={adata} pagination={false} />
            </Panel>
            <Panel header={thead} key="3">
              <Table columns={acolumns} dataSource={adata} pagination={false} />
            </Panel>  */}
          </Collapse>
          <div className="btnwrp">
            <ButtonField
              className="CancelGradiantBtn"
              type="primary"
              htmlType="Back"
              label="Back"
              onClick={() => navigate(`/request-for-quotation/float-rfq-assign-pr/${categoryTreeId}`)}
            />
          </div>
        </div>
      </section>
    </>
  );
};
export default FloatRFQPurchaseRequisitionAssignDetails;
